// extracted by mini-css-extract-plugin
export default {"FooterRight":"FooterRightArea_FooterRight__KPaGt","footer":"FooterRightArea_footer__OKLva"};